<div mat-dialog-title class="!flex">
  <div class="flex flex-row w-full flex-nowrap justify-between">
    <h2 class="dialog-title">{{ longName }}</h2>

    <fa-icon
      class="icon-close"
      size="2x"
      [icon]="faTimes"
      mat-dialog-close
      title="{{ 'common.confirm.CLOSE' | transloco }}"
    ></fa-icon>
  </div>
</div>

<mat-dialog-content>
  <market-details [dataSource]="datasource"></market-details>
</mat-dialog-content>
